import { createContext } from 'react'

import type { AbTestsAddEditContextType } from './types'

export const AbTestsAddEditContext = createContext<AbTestsAddEditContextType>(
  {} as AbTestsAddEditContextType,
)
